import { render, staticRenderFns } from "./SectionRegister.vue?vue&type=template&id=33303aa6&"
import script from "./SectionRegister.vue?vue&type=script&lang=js&"
export * from "./SectionRegister.vue?vue&type=script&lang=js&"
import style0 from "./SectionRegister.vue?vue&type=style&index=0&id=33303aa6&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GDPRConsent: require('/home/smiley/3df/components/GDPRConsent.vue').default})
